import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "bold" }
const _hoisted_2 = {
  class: "mt-4",
  style: {"width":"100%","overflow":"auto"}
}

import { computed, nextTick, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { useCreatingForm } from '@/core/hooks/use-creating-form';
import { useDateTime } from '@/core/hooks/use-date-time-hook';
import { useLoading } from '@/core/hooks/use-loading';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import {
  IHopDongResponseBase,
  IKhoResponseBase,
  ITheoDoiThucHienHopDongResponseBase
} from '@/core/interfaces/ApiResponses';
import { swalErrNotification } from '@/core/helpers/utils';
import { HopDongService } from '@/core/services/HopDong.service';
import { KhoService } from '@/core/services/Kho.service';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import TheoDoiHopDongPrintModal from './print-modals/TheoDoiHopDongPrintModal.vue';
import TheoDoiHopDongTable from './table-components/TheoDoiHopDongTable.vue';
import { BaoCaoService } from "@/core/services/BaoCao.service";
import ResponsiveLayout from '@/layout/_shared/ResponsiveLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheoDoiHopDong',
  setup(__props) {

setCurrentPageTitle('Báo cáo');

const { startLoading, endLoading } = useLoading();

const { formRef } = useCreatingForm();

const printModal = ref();

const { defaultDate, disableDate, formatDisplayingDate } = useDateTime();

const store = useStore();

const currentYear = computed(() => store.getters.getSelectedYear);

const khoItems = ref<IKhoResponseBase[]>([]);

const hopDongOptions = ref<IHopDongResponseBase[]>([]);

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

const fetchKhoItems = async () => {
  await startLoading();

  try {
    const { data: { data: { data } } } = await KhoService.fetchAllWarehouses();

    khoItems.value = data;

    await endLoading();
  } catch (e) {
    await endLoading();

    await swalErrNotification(e, 'Có lỗi khi lấy danh sách kho');
  }
}

const searchingHopDong = ref(false);

const searchHopDong = async (query) => {
  searchingHopDong.value = true;

  const { data: { data: { data } } } = await HopDongService.fetchAllContracts(1, 2000, query);

  hopDongOptions.value = data;

  searchingHopDong.value = false;
}

const selectingHopDong = computed(() => {
  if (!form.value.hopDongId) return null;

  return hopDongOptions.value.find(({ id }) => id === form.value.hopDongId)
})

onMounted(() => {
  nextTick(async () => {
    await fetchKhoItems();
  });
});

const isFiltersChanging = ref(true);

const form = ref({
  hopDongId: -1,
  khoId: -1,
  to: defaultDate.value,
});

const selectingKho = computed(() => {
  if (!form.value.khoId) return null;

  return khoItems.value.find(({ id }) => id === form.value.khoId);
});

const showPrintButton = computed(() => {
  if (isFiltersChanging.value) return false;

  if (!resultItems.value.length) return false;

  return !(!selectingKho.value || !form.value.to || !selectingHopDong.value);
});

const resultItems = ref<ITheoDoiThucHienHopDongResponseBase[]>([]);

const generate = () => {
  if (!formRef.value) return;

  formRef.value.validate(async (isValid: boolean) => {
    if (isValid) {
      isFiltersChanging.value = false;

      await startLoading();

      try {
        const { data: { data: res } } = await BaoCaoService.getTheoDoiThucHienHopDong({
          idHopDong: selectingHopDong.value?.id ?? 0,
          idKho: selectingKho.value?.id ?? 0,
          month: form.value.to.getMonth() + 1,
        });

        resultItems.value = res;

        await endLoading();
      } catch (e) {
        await endLoading();

        await swalErrNotification(e, 'Có lỗi xảy ra');
      }
    } else return false;
  });
}

const rules = {
  hopDongId: [
    {
      type: 'number',
      message: 'Phải chọn hợp đồng',
      trigger: 'change',
      min : 1,
    }
  ],
  khoId: [
    {
      type: 'number',
      message: 'Phải chọn kho',
      trigger: 'change',
      min : 1,
    }
  ],
  to: [
    {
      type: 'date',
      message: 'Phải chọn ngày',
      trigger: 'change',
      required: true,
    }
  ]
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheoDoiHopDongPrintModal, {
      ref_key: "printModal",
      ref: printModal,
      "hop-dong": selectingHopDong.value ?? null,
      items: resultItems.value,
      kho: selectingKho.value ?? null,
      to: form.value.to,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (printModal.value.isOpen = false))
    }, null, 8, ["hop-dong", "items", "kho", "to"]),
    _createVNode(PageRowLayout, null, {
      "page-row-header": _withCtx(() => [
        _createTextVNode(" Theo dõi thực hiện hợp đồng ")
      ]),
      "page-row-content": _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: rules,
          onSubmit: _withModifiers(generate, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Kho:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "khoId",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.value.khoId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.khoId) = $event)),
                      class: "w-100",
                      name: "khoId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          disabled: "",
                          label: "Chọn kho",
                          value: -1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(khoItems.value, (kho) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: kho.id,
                            label: kho.ten_kho,
                            value: kho.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Đến tháng:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "to",
                  class: "mb-0"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: form.value.to,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.to) = $event)),
                      class: "w-100",
                      "disabled-date": (time) => _unref(disableDate)(time, currentYear.value, true),
                      type: "month",
                      placeholder: "đến",
                      name: "to",
                      format: "MM/YYYY"
                    }, null, 8, ["modelValue", "disabled-date"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ResponsiveLayout, null, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hợp đồng:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  class: "mb-0",
                  prop: "hopDongId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: form.value.hopDongId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.hopDongId) = $event)),
                      class: "w-100",
                      filterable: "",
                      remote: "",
                      placeholder: "tìm kiếm",
                      "remote-method": searchHopDong,
                      loading: searchingHopDong.value,
                      "loading-text": "đang tìm kiếm ...",
                      name: "hopDongId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          disabled: "",
                          label: "Tìm hợp đồng",
                          value: -1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hopDongOptions.value, (hopDong) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: hopDong.id,
                            label: hopDong.so_hop_dong,
                            value: hopDong.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_1, _toDisplayString(hopDong.so_hop_dong), 1),
                              _createTextVNode(" - " + _toDisplayString(hopDong.ten_doi_tac), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading"])
                  ]),
                  _: 1
                })
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ngày ký:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                _createVNode(LabelCustom, { "is-text-muted": true }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(selectingHopDong.value?.ngay_ky
                  ? _unref(formatDisplayingDate)(new Date(selectingHopDong.value.ngay_ky))
                  : 'Chưa chọn HĐ'), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(ResponsiveLayout, { class: "mb-5" }, {
              "col-1": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Tài khoản:")
                  ]),
                  _: 1
                })
              ]),
              "col-2": _withCtx(() => [
                (selectingHopDong.value)
                  ? (_openBlock(), _createBlock(LabelCustom, {
                      key: 0,
                      "is-text-muted": false
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(selectingHopDong.value.ma_tk) + " / " + _toDisplayString(selectingHopDong.value.ma_ct), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(LabelCustom, {
                      key: 1,
                      "is-text-muted": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Chưa chọn HĐ")
                      ]),
                      _: 1
                    }))
              ]),
              "col-3": _withCtx(() => [
                _createVNode(LabelCustom, {
                  "is-text-muted": true,
                  "is-required": false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Đ/vị cung cấp vật tư, hàng hoá:")
                  ]),
                  _: 1
                })
              ]),
              "col-4": _withCtx(() => [
                (selectingHopDong.value)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: selectingHopDong.value.ten_doi_tac,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectingHopDong.value.ten_doi_tac) = $event)),
                      disabled: "",
                      readonly: "",
                      rows: 1,
                      type: "textarea"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createBlock(LabelCustom, {
                      key: 1,
                      "is-text-muted": true
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Chưa chọn HĐ")
                      ]),
                      _: 1
                    }))
              ]),
              _: 1
            }),
            _createVNode(DivRow, null, {
              default: _withCtx(() => [
                _createVNode(DivCol, { cols: 8 }),
                _createVNode(DivCol, {
                  cols: 4,
                  class: "d-flex justify-content-end"
                }, {
                  default: _withCtx(() => [
                    (showPrintButton.value)
                      ? (_openBlock(), _createBlock(ButtonCustom, {
                          key: 0,
                          "button-type": _unref(ButtonsType).FA_PRINT,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (printModal.value.isOpen = true))
                        }, {
                          "button-label": _withCtx(() => [
                            _createTextVNode("In phiếu")
                          ]),
                          _: 1
                        }, 8, ["button-type"]))
                      : _createCommentVNode("", true),
                    _createVNode(ButtonCustom, {
                      "button-type": _unref(ButtonsType).FA_FILE_EXPORT_THIN,
                      "color-type": _unref(ButtonTypeColors).SUCCESS,
                      onClick: generate
                    }, null, 8, ["button-type", "color-type"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TheoDoiHopDongTable, { items: resultItems.value }, null, 8, ["items"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})